import React from 'react';

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
};

export default Spinner;